module.exports = __webpack_public_path__ + "img/Project.3d82ceaa.png";